import { AvField } from "availity-reactstrap-validation"
import { useEffect, useState } from "react"
import { Alert, Row, Col } from "reactstrap"

import Licensing from "services/Licensing.service"

const user = JSON.parse(localStorage.getItem("authUser"))
let licensingService = new Licensing(user)

const CountriesStates = props => {
  const [defaultExports, setdefaultExports] = useState({})
  const defaultCountries = () => {
    let tmpCountries = []
    for (let kount = 0; kount < maxLen; kount++) {
      tmpCountries.push({ export: "", transit: "", import: "" })
    }

    return tmpCountries
  }

  const [countriesLen, setcountriesLen] = useState(3)
  const [rows, setrows] = useState([])
  const maxLen = 10
  const [countries, setCountries] = useState(defaultCountries)

  useEffect(() => {
    populateTableRows(countries, countriesLen)
    fetchTransitStates(props.appId)
  }, [])

  useEffect(() => {
    if (countries.length > 1) {
      populateTableRows(countries, countriesLen)
    }
  }, [countriesLen])

  const addRow = () => {
    if (countriesLen < maxLen) {
      setcountriesLen(countriesLen + 1)
    }
  }

  const deleteLastRow = () => {
    if (countriesLen > 0) {
      setcountriesLen(countriesLen - 1)
    }
  }

  const handleValueChange = e => {
    let [inputName, index] = e.target.name.split("_")

    let tmpCountries = countries
    if (inputName === "import") {
      tmpCountries[index].import = e.target.value
    } else if (inputName === "export") {
      tmpCountries[index].export = e.target.value
    } else if (inputName === "transit") {
      tmpCountries[index].transit = e.target.value
    }

    setCountries(tmpCountries)
  }

  const populateTableRows = (countries, len) => {
    let rows = []
    for (let kount = 0; kount < len; kount++) {
      rows.push(
        <tr key={kount}>
          <td>{kount + 1}</td>
          <td>
            <AvField
              type="text"
              name={"export_" + kount}
              value={countries[kount].export}
              onChange={handleValueChange}
            />
          </td>
          <td>
            <AvField
              type="text"
              name={"transit_" + kount}
              value={countries[kount].transit}
              onChange={handleValueChange}
            />
          </td>
          <td>
            <AvField
              type="text"
              name={"import_" + kount}
              value={countries[kount].import}
              onChange={handleValueChange}
            />
          </td>
        </tr>
      )
    }
    setrows(rows)
  }

  const fetchTransitStates = appId => {
    licensingService.getClientTransitStates(appId).then(response => {
      let tmpCountries = []
      if (response.status) {
        setcountriesLen(response.data.length)
        response.data.forEach(item => {
          tmpCountries.push({ export: item.state_of_dispatch, transit: item.state_of_transit, import: item.state_of_destination })
        });
        for (let kount = response.data.length; kount < maxLen; kount++) {
          tmpCountries.push({ export: "", transit: "", import: "" })
        }
        setCountries(tmpCountries)
        populateTableRows(tmpCountries, response.data.length)
      }
    })
  }

  return (
    <>
      <div>
        <Row className="pull-right">
          <span className="btn btn-primary" onClick={addRow}>
            <i className="fa fa-plus"></i> Add Row
          </span>
        </Row>
      </div>
      <table className="table table-responsive table-striped table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>State of export - dispatch</th>
            <th>State(s) of transit (entry and exit)</th>
            <th>State of import - destination</th>
          </tr>
        </thead>

        <tbody>
          {rows}
          <tr>
            <td colSpan={4}>
              <Row className="pull-right">
                <span className="btn btn-danger" onClick={deleteLastRow}>
                  <i className="fa fa-trash"></i> Delete Last Row
                </span>
              </Row>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default CountriesStates
